import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import EChartsReact from "echarts-for-react";
import DashboardService from "../../Services/DashboardService";
import { EmptyIcon } from "../../Common/FullPageSpinner";

interface ISubmissionCardProps {
  practiceId: number | null;
  fromDate: string;
  toDate: string;
}

const SubmissionCard = (props: ISubmissionCardProps) => {
  const [chartOptions, setChartOptions] = React.useState<any>({
    xData: [],
    yData: [],
  });
  const [loader, setLoader] = React.useState<boolean>(true);

  React.useEffect(() => {
    if (!props?.practiceId) {
      setChartOptions({ xData: [], yData: [] }); // Reset chart data when no selection
      return;
    }
    setLoader(true);
    DashboardService.getSubmissionDetails(
      props?.practiceId,
      props?.fromDate,
      props?.toDate,
    )
      .then((response) => {
        if (response.status && response.result) {
          const xData = Object.keys(response.result);
          const yData = Object.values(response.result);
          for (var i = 0; i < xData.length; i++) {
            xData[i] = xData[i].toUpperCase();
          }
          setChartOptions({ xData, yData }); // Update chart data
        } else {
          setChartOptions({ xData: [], yData: [] });
        }
      })
      .catch((error) => {
        console.error("Error fetching chart data:", error);
        setChartOptions({ xData: [], yData: [] });
      })
      .finally(() => {
        setLoader(false);
      });
  }, [props.practiceId, props.fromDate, props.toDate]);

  return (
    <>
      <Spin
        spinning={loader}
        indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />}
      >
        {chartOptions.xData.length > 0 && chartOptions.yData.length > 0 ? (
          <EChartsReact
            style={{ width: "100%" }}
            option={{
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow",
                },
                formatter: function (params: any) {
                  if (Array.isArray(params) && params.length > 0) {
                    return params
                      .map((item: any) => {
                        return `
            <div>
              ${item.name}<br/>
              ${item.seriesName}: 
              <span style="color:#000; font-weight:600;">
                ${item.value}
              </span>
            </div>
          `;
                      })
                      .join("");
                  }
                  return "";
                },
              },
              toolbox: {
                show: true,
                showTitle: false,
                orient: "vertical",
                right: 4,
                top: 24,
                feature: {
                  // dataView: { show: true, readOnly: false },
                  magicType: { show: true, type: ["line", "bar"] },
                  saveAsImage: { show: true },
                },
              },
              grid: {
                left: "4%",
                right: "5%",
                //  top: "16%",
                bottom: "3%",
                containLabel: true,
              },
              xAxis: [
                {
                  type: "category",
                  data: chartOptions.xData,
                  axisTick: {
                    alignWithLabel: true,
                  },
                },
              ],
              yAxis: [
                {
                  type: "value",
                },
              ],
              series: [
                {
                  name: `Submissions`,
                  type: "line",
                  barWidth: "55%",
                  showSymbol: false,
                  data: chartOptions?.yData,
                },
              ],
            }}
          />
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: 80,
              gap: 8,
            }}
          >
            <EmptyIcon />
          </div>
        )}
      </Spin>
    </>
  );
};

export default SubmissionCard;
